import { NgModule, Optional, SkipSelf } from '@angular/core';
import { PipesModule } from './pipes/pipes.module';
import { WebSocketModule } from './websocket/websocket.module';
import { AuthModule } from './auth/auth.module';
import { IconsModule } from './icons/icons.module';
import { TranslocoCoreModule } from './transloco/transloco.module';

@NgModule({
    imports: [
        AuthModule,
        IconsModule,
        PipesModule,
        TranslocoCoreModule,
        WebSocketModule
    ]
})
export class CoreModule
{
    /**
     * Constructor
     */
    constructor(
        @Optional() @SkipSelf() parentModule?: CoreModule
    )
    {
        // Do not allow multiple injections
        if ( parentModule )
        {
            throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
        }
    }
}
